module.exports = __webpack_public_path__ + "img/clock.e82eedce.svg";